export const Ski = (props) => {
  return (
    <div id='services' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Школа горных лыж и сноуборда</h2>

        </div>
        <div className='row'>

          <div className='col-md-4'>
            <div className='icon'>
              <img
                src="img/instructors/tren_181122.jpg"
                className='img-responsive'

              >
              </img>
            </div>
            <div className='service-desc'>
              <h3>Яблоков Андрей</h3>
              <p>Главный инструктор Школы горных лыж YES</p>
              <p>Профиль работ: обучение катанию на горных лыжах.</p>
              <p>Взрослые и дети (с 4 лет). Категория: C.</p>
              <p>Мончегорская СШОР по горнолыжному спорту.</p>
              <p>«Федеральный научный центр физической культуры и спорта»(ФГБУ ФНЦ ВНИИФК) по программе : «Теория и методика горнолыжного спорта».</p>
              <p>National Russia (Методика обучения детей технике горнолыжного спорта). НЛИ в соответствии с международными стандартами обучения International Ski Instructors Association (ISIA).</p>
              <p>
                {/* <a href={d.link} className="btn btn-custom btn-lg page-scroll">Записаться</a> */}

                {/* <button className="btn-zayavka"><a href="https://b24-ir4qg1.bitrix24.site/ski_yes35/">Оставить заявку в Школу горных лыж</a></button> */}
                <button className="btn-zayavka disabled">Школа сформирована</button>

              </p>
            </div>
          </div>

          {/* <div className='col-md-4'>
            <div className='icon'>
              <img
                src="https://instructors.yes35.ru/img/instructors/check18.jpg"
                className='img-responsive'

              >
              </img>
            </div>
            <div className='service-desc'>
              <h3>Высоцкая Ксения</h3>
              <p>Профиль работы: обучение катанию на сноуборде.</p>
              <p>Взрослые и дети (с 5 лет)</p>
              <p>Вид занятий: индивидуальные занятия.</p>
              <p>Стаж преподавания: с 2023 года.</p>
              <p>Стаж индивидуального катания: с 1998 года.</p>
              <p>
                <button className="btn-zayavka"><a href="https://b24-ir4qg1.bitrix24.site/snowboard_yes35/">Оставить заявку в Школу сноуборда</a></button>
              </p>
            </div>
          </div> */}

          <div className='col-md-4'>
            <div className='icon'>
              <img
                src={'img/instructors/chek22.jpg'}
                className='img-responsive'
              >
              </img>
            </div>
            <div className='service-desc'>
              <h3>Батенёва Светлана</h3>
              <p>Профиль работы: обучение катанию на горных лыжах.</p>
              <p>Взрослые и дети (с 7 лет).</p>
              <p>Пройдено обучение в Национальной Лиге инструкторов 2024г.</p>
              <p>Стаж индивидуального катания: с 2009 года.</p>
              <p>Вид занятий: индивидуальные тренировки, для учеников без опыта катания</p>
              <button className="btn-zayavka"><a href="https://b24-ir4qg1.bitrix24.site/ski_yes35/" target="_blank">Оставить заявку</a></button>
              {/* <button className="btn-zayavka disabled">Набор с 12.01.2026</button>  */}
            </div>
          </div>

          <div className='col-md-4'>
            <div className='icon'>
              <img
                src={'img/instructors/bvf20012026_2.jpeg'}
                className='img-responsive'
              >
              </img>
            </div>
            <div className='service-desc'>
              <h3>Беспалов Владимир Федорович</h3>
              <p>Инструктор Школы горных лыж выходного дня.</p>
              <p>Образование: Петрозаводский государственный университет по направлению горные лыжи.</p>
              <p>Стаж катания с 1961 года.</p>
              <p>Стаж тренера с 1972 года.</p>
              <p>Для детей 7-8 лет с опытом самостоятельного подъема на канатной дороге.</p>
              <p>Занятия будут проходить в cубботу и воскресенье в 10:15.</p>
              <p>Стоимость 1500р/чел за занятие.</p>
              <button className="btn-zayavka"><a href="https://b24-ir4qg1.bitrix24.site/crm_form_hqdvb/" target="_blank">Оставить заявку</a></button>
              {/* <button className="btn-zayavka disabled">Набор с 12.01.2026</button>  */}
            </div>
          </div>

        </div>

      </div>
    </div>
  )
}
